import { z } from 'zod';
import { pageFilter } from './common';

export const chatFilter = z.object({
  ...pageFilter.shape,
});

export type ChatFilter = z.infer<typeof chatFilter>;
